// @ts-nocheck
import { Users } from 'lucide-react';
import { toast } from 'sonner';
import { c, Section, Switch, useNode } from '../ui';

export default function HandoverSection({ next, onNext, value, onChange }) {
  const node = useNode('handover');
  const set = (on) => {
    onChange(on);
    toast.success(on ? 'Human Handover enabled' : 'Human Handover disabled');
  };
  return (
    <Section
      id="handover"
      icon={Users}
      title="Human handover"
      sub="Let callers reach a live person."
      tag={value ? 'on' : 'off'}
      ok={node.ok}
      next={next('handover')}
      onNext={onNext}
    >
      <div className={c('tog')}>
        <Switch checked={value} onChange={set} label="Human handover" />
        <b>{value ? 'Transfer to a person is on' : 'Transfer to a person is off'}</b>
      </div>
      <p className={c('note')} style={{ margin: 0 }}>
        {value
          ? 'The agent can transfer the call to a live person when the caller asks, or when it cannot answer.'
          : 'When off, a request for a person ends the call and is reported as a completion type.'}
      </p>
    </Section>
  );
}
